export const agenda = {
  agendaDuration: '기간',
  agendaCurtainCopy: '링크 복사',
  agendaCurtainFlag: '콘텐츠 신고',
  agendaCurtainFlagSent: '콘텐츠가 신고되었습니다',
  agendaLinkCopied: '링크가 복사되었습니다!',
  agendaStartsAt: '시작 시간 ',
  agendaEndsAt: '종료 시간 ',
  agendaSpeakers: '스피커',
  agendaSeeAllSpeakers: '전체 보기',
  agendaAddToSchedule: '내 일정에 추가',
  agendaRemoveFromSchedule: '내 일정에서 제거',
  agendaAddedToSchedule: '내 일정에 추가되었습니다!',
  agendaRemovedFromSchedule: '내 일정에서 제거되었습니다!',
  agendaCalendar: '캘린더',
  agendaAddToCalendar: '시스템 캘린더에 추가하시겠습니까?',
  agendaCalendarSkip: '건너뛰기',
  agendaCalendarAdd: '추가',
  agendaNow: '지금',
  agendaModerators: '모더레이터'
}
